function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { themeGet } from '@styled-system/theme-get';
import React, { memo } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import Box from './Box';
const variantStyles = variant({
  key: 'listGroupItems'
});
const StyledListGroupItem = styled(Box).withConfig({
  displayName: "ListGroupItem__StyledListGroupItem",
  componentId: "sc-1qyulzl-0"
})(["", " display:block;width:100%;border:none;text-align:left;line-height:1.5;text-decoration:none;& + &{border-top:", ";}"], variantStyles, props => themeGet('borders.default')(props));
const ListGroupItem = /*#__PURE__*/memo(_ref => {
  let {
    children,
    px = [3, 4],
    py = [2, 3],
    variant = 'default',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledListGroupItem, _extends({
    px: px,
    py: py,
    variant: variant
  }, props), children);
});
ListGroupItem.propTypes = {
  ...Box.propTypes,
  ...variantStyles.propTypes
};
ListGroupItem.displayName = 'ListGroupItem';
export default ListGroupItem;